/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["nửa đêm", "tr", "sáng", "chiều", "tối", "đêm"], ["nửa đêm", "TR", "sáng", "chiều", "tối", "đêm"], u], [["nửa đêm", "trưa", "sáng", "chiều", "tối", "đêm"], ["nửa đêm", "TR", "sáng", "chiều", "tối", "đêm"], ["nửa đêm", "trưa", "sáng", "chiều", "tối", "đêm"]], ["00:00", "12:00", ["04:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "04:00"]]];
